/* unplugin-vue-components disabled */import { render } from "./AlgorithmCard.vue?vue&type=template&id=f26ee1c6&scoped=true"
import script from "./AlgorithmCard.vue?vue&type=script&lang=js"
export * from "./AlgorithmCard.vue?vue&type=script&lang=js"

import "./AlgorithmCard.vue?vue&type=style&index=0&id=f26ee1c6&lang=scss&scoped=true"

import exportComponent from "D:\\pangu_artificial_intelligence_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f26ee1c6"]])

export default __exports__